<template>
  <!-- <vue-scrollbar style="width:100%; height:100%;"> -->
    <el-table
      :data="data"
      :dynamicOperationName="dynamicOperationName"
      highlight-current-row
      :height="height"
      ref="readImageList"
      @selection-change="handleSelectionChange"
      @current-change="handleCurrentChange"
      style="width: 100%;">
      <el-table-column
        type="selection"
        width="26"
        v-if="showCheck"
       >
      </el-table-column>
      <el-table-column v-for="item in head"
                      :show-overflow-tooltip="show"
                       :prop="item.props"
                       :width="item.columnWidth"
                       :label="item.label"
                       :min-width="item.width"
                       v-if="(item.props=='reportEvidences'||item.props=='reportConclusion') ? false : true"
                       >  <!--reportEvidences，reportConclusion列表中不显示-->
      </el-table-column>
    </el-table>
  <!-- </vue-scrollbar> -->
</template>

<script type="text/ecmascript-6">
  // import VueScrollbar from 'vue2-scrollbar'
  import {nomalTime} from '@/common/js/time'

  export default {
    components:{
      // VueScrollbar
    },
    props: {
      showCheck:{
        type: Boolean,
        default: false,
      },
      height: {
        type: String,
        default: '100%'
      },
      data: {
        type: Array,
        default: function () {
          return []
        }
      },
      head: {
        type: Array,
        default: []
      },
      operation: {
        type: Array,
        default: function () {
          return []
        },
      },
      operationWidth: {
        type: Number,
        default: 200
      },
      width:{
        type: String,
        default: ''
      },
      dynamicOperationName: {
        type: String,
        default: ''
      },
      readImgList: {
        type: Array,
        default: () => []
      },
    },
    computed: {},
    watch:{},
    created() {},
    mounted() {
    },
    methods: {
      handleCurrentChange(val) {
        val.createDate = nomalTime(val.createDate)
        this.$emit('showDetial', val);
      },
      handleSelectionChange(val){
        // 表格选中事件
        val.createDate = nomalTime(val.createDate)
        this.$emit('readImg', val);

      },
       clearList(){
        this.$refs.multipleTable.clearSelection()
      }
    },
    data() {
      return {
        show: true,
        applyToMeOperation: [],
        currentRow: null,
        oldList: [],
      }
    }
  }
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
  @import '~@/common/css/variable.styl'
</style>



// WEBPACK FOOTER //
// reportTable.vue?29798cae